<template>
    <el-dialog
        ref="DetailDialog"
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        append-to-body
        class="payment-export-pdf-dialog ah-detail-dialog"
        top="5vh"
        @open="onOpen"
        @close="onClose"
        @closed="onClosed"
    >
        <template slot="title">請款單 PDF 匯出</template>
        <div class="export-pdf-layout">
            <div class="preview-view">
                <div class="preview-area">
                    <div class="preview-list">
                        <div class="preview-doc">
                            <div class="preview-page detail">
                                <div class="title">請款單</div>
                                <div v-if="form.enableDrawLogo" class="logo">LOGO</div>
                                <div v-if="form.enableDrawAuditProgress" class="audits">
                                    <div class="line" />
                                    <div class="dot" />
                                    <div class="dot" />
                                    <div class="dot" />
                                </div>
                                <span class="title-text-line" />
                                <span class="title-text-line" />
                                <div class="section">
                                    <div class="section-title"><span class="title-text" /></div>
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                </div>
                                <div class="section">
                                    <div class="section-title"><span class="title-text" /></div>
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                </div>
                                <div class="section">
                                    <div class="section-title"><span class="title-text" /></div>
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                </div>
                                <div class="section sign">
                                    <div v-if="form.enableDrawCreatorSignRect" class="signRect creator"></div>
                                    <div v-else></div>
                                    <div v-if="form.enableDrawAuditSignRect" class="signRect audit"></div>
                                    <div v-else></div>
                                    <div v-if="form.enableDrawReceiverSignRect" class="signRect receiver"></div>
                                    <div v-else></div>
                                </div>
                            </div>
                            <div v-if="form.enableDrawReceipts" class="preview-page detail">
                                <div class="title">檢附單據</div>
                                <div v-if="form.enableDrawLogo" class="logo">LOGO</div>
                                <span class="title-text-line" />
                                <span class="title-text-line" />
                                <div class="section">
                                    <div class="section-title"><span class="title-text" /></div>
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                </div>
                                <div class="section">
                                    <div class="section-title"><span class="title-text" /></div>
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                </div>
                                <div class="section">
                                    <div class="section-title"><span class="title-text" /></div>
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                </div>
                                <div class="section sign">
                                    <div v-if="form.enableDrawCreatorSignRect" class="signRect creator"></div>
                                    <div v-else></div>
                                    <div v-if="form.enableDrawAuditSignRect" class="signRect audit"></div>
                                    <div v-else></div>
                                    <div v-if="form.enableDrawReceiverSignRect" class="signRect receiver"></div>
                                    <div v-else></div>
                                </div>
                            </div>
                            <div v-if="form.enableDrawVouchers" class="preview-page detail">
                                <div class="title">傳票</div>
                                <div v-if="form.enableDrawLogo" class="logo">LOGO</div>
                                <span class="title-text-line" />
                                <span class="title-text-line" />
                                <div class="section">
                                    <div class="section-title"><span class="title-text" /></div>
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                </div>
                                <div class="section">
                                    <div class="section-title"><span class="title-text" /></div>
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                </div>
                                <div class="section">
                                    <div class="section-title"><span class="title-text" /></div>
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                    <span class="title-text-line" />
                                </div>
                                <div class="section sign">
                                    <div v-if="form.enableDrawCreatorSignRect" class="signRect creator"></div>
                                    <div v-else></div>
                                    <div v-if="form.enableDrawAuditSignRect" class="signRect audit"></div>
                                    <div v-else></div>
                                    <div v-if="form.enableDrawReceiverSignRect" class="signRect receiver"></div>
                                    <div v-else></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="setting-view">
                <div class="setting-content">
                    <el-form ref="form" :model="form" label-width="100px" label-position="top">
                        <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                            <div>匯出設定</div>
                            <div>共 {{ snoList.length }} 筆</div>
                        </div>
                        <el-form-item>
                            <div class="custom-settings">
                                <div class="item">
                                    <el-checkbox
                                        v-model="form.enableDrawPaymentDetail"
                                        @change="saveSettingsToLocalStorage"
                                    >請款內容</el-checkbox>
                                </div>
                                <div class="item" style="margin-left: 25px;">
                                    <el-checkbox
                                        v-model="form.enableDrawLogo"
                                        :disabled="!isLogoAvalible || !form.enableDrawPaymentDetail"
                                        @change="saveSettingsToLocalStorage"
                                    >公司Logo <span v-if="!isLogoAvalible">（尚未設定）</span></el-checkbox>
                                </div>
                                <div class="item" style="margin-left: 25px;">
                                    <el-checkbox
                                        v-model="form.enableDrawAuditProgress"
                                        :disabled="!form.enableDrawPaymentDetail"
                                        @change="saveSettingsToLocalStorage"
                                    >審核流程</el-checkbox>
                                </div>
                                <div class="item" style="margin-left: 25px;">
                                    <el-checkbox
                                        v-model="form.enableDrawCreatorSignRect"
                                        :disabled="!form.enableDrawPaymentDetail"
                                        @change="saveSettingsToLocalStorage"
                                    >申請人簽章欄</el-checkbox>
                                </div>
                                <div class="item" style="margin-left: 25px;">
                                    <el-checkbox
                                        v-model="form.enableDrawAuditSignRect"
                                        :disabled="!form.enableDrawPaymentDetail"
                                        @change="saveSettingsToLocalStorage"
                                    >審核人簽章欄</el-checkbox>
                                </div>
                                <div class="item" style="margin-left: 25px;">
                                    <el-checkbox
                                        v-model="form.enableDrawReceiverSignRect"
                                        :disabled="!form.enableDrawPaymentDetail"
                                        @change="saveSettingsToLocalStorage"
                                    >收款人簽章欄</el-checkbox>
                                </div>
                                <div class="item" style="margin-top: 20px;">
                                    <el-checkbox
                                        v-model="form.enableDrawReceipts"
                                        @change="saveSettingsToLocalStorage"
                                    >檢附單據</el-checkbox>
                                </div>
                                <div v-if="isPayed('G01')">
                                    <div class="item">
                                        <el-checkbox
                                            v-model="form.enableDrawVouchers"
                                            @change="saveSettingsToLocalStorage"
                                        >會計傳票</el-checkbox>
                                    </div>
                                    <div class="item" v-if="form.enableDrawVouchers" style="margin-left: 25px;">
                                        <div>傳票列印方向：
                                            <el-select
                                                v-model="form.voucherOrientation"
                                                size="small"
                                                :disabled="!form.enableDrawVouchers"
                                                @change="saveSettingsToLocalStorage"
                                            >
                                                <el-option label="直式傳票" value="portrait"></el-option>
                                                <el-option label="橫式傳票（建議 A5 列印）" value="landscape"></el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="actions">
                    <el-button @click="onClose">取消</el-button>
                    <el-button type="primary" class="primary-action" :disabled="isExporting" :loading="isExporting" @click="onExport">{{ isExporting ? "匯出中..." : "匯出" }}</el-button>
                </div>
            </div>
            <div v-if="isExporting" class="progress-view">
                <div class="progress-panel">
                    <div class="panel-title">匯出中</div>
                    <div class="progress-bar">
                        <el-progress :percentage="processPercentage" :show-text="false" :stroke-width="10"></el-progress>
                    </div>
                    <div class="progress-msg">{{ this.processMsg }}</div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import JSZip from 'jszip';
import { PDFDocument } from 'pdf-lib';
import VoucherPdfDef from '@/utils/PdfDefinitions/VoucherPdfDef';
import VoucherPdfFormater from '@/utils/PdfDataFormaters/VoucherPdfFormater';
import PaymentDetailPdfDef from '@/utils/PdfDefinitions/PaymentDetailPdfDef';
import PaymentDetailPdfFormater from '@/utils/PdfDataFormaters/PaymentDetailPdfFormater';
import PaymentReceiptPdfDef from '@/utils/PdfDefinitions/PaymentReceiptPdfDef';
import PaymentReceiptPdfFormater from '@/utils/PdfDataFormaters/PaymentReceiptPdfFormater';
import { ensureNotoSansTCFontsLoaded, isNotoSansTCFontsLoaded, startEstimatedProgressTicker } from '@/utils/PdfHelpers';

export default {
    name: 'payment-export-pdf-dialog',
    props: ['visible'],
    data() {
        return {
            snoList: [],
            bankAccountList: [],
            fileTypes: [],
            isLogoAvalible: false,
            isExporting: false,
            processMsg: '',
            processPercentage: 0,
            form: {
                enableDrawPaymentDetail: true,
                enableDrawLogo: true,
                enableDrawAuditProgress: true,
                enableDrawReceipts: true,
                enableDrawCreatorSignRect: true,
                enableDrawReceiverSignRect: true,
                enableDrawAuditSignRect: true,
                enableDrawVouchers: false,
                voucherOrientation: 'portrait', // portrait | landscape
            },
            pdfSetting: {
                pageWidth: 1000,
                pageHeight: 1414,
            },
        };
    },
    created() {},
    mounted() {},
    computed: {
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
    },
    methods: {
        setSnoList(snoList) {
            this.snoList = snoList;
        },
        onOpen() {
            this.loadSettingsFromLocalStorage();

            // 判斷 Logo 是否存在
            const { logo } = this.$store.getters['menu/companyInfo'];
            this.isLogoAvalible = !!logo;
            this.form.enableDrawLogo = this.isLogoAvalible;
        },
        onClose() {
            this.refreshData();
            this.$emit('close');
        },
        onClosed() {
            this.refreshData();
        },
        refreshData() {
            this.processMsg = '';
            this.processPercentage = 0;
        },

        // 載入公司 LOGO base64 格式
        async fetchCmpLogoBase64() {
            try {
                const resp = await this.$api({
                    url: '/Tool/GetBase64Logo',
                    method: 'GET',
                });
                // 由於這支API返回的Base64格式缺少檔案類型的資料，需要從前面的字元去判斷圖片類型，並在前頭加上對應的格式代碼
                const base64String = resp.data;

                // 檢查 base64 字串是否已經包含正確的前綴
                if (base64String.indexOf('data:image/') === 0) {
                    return base64String;
                }

                // 用第一個字元判斷檔案類型
                let imageType = 'jpg'; // 預設為 jpg
                const firstChar = base64String.charAt(0);
                if (firstChar === 'i') {
                    imageType = 'png';
                }

                // 添加回檔案類型到 base64String
                return `data:image/${imageType};base64,${base64String}`;
            } catch (ex) {
                console.log('fetchFiles error', ex);
                return null;
            }
        },

        // 批次匯出 PDF 打包為 ZIP 並下載
        /* eslint-disable no-await-in-loop */
        async onExport() {
            const paymentCount = this.snoList.length; // 請款單張數

            // 進度條權重：字型下載 = 1 單位（若已快取則為 0），每張請款 = 1 單位
            const fontWeight = isNotoSansTCFontsLoaded() ? 0 : 1;
            const totalWeight = fontWeight + paymentCount;
            const fontProgressSlice = (fontWeight / totalWeight) * 100;
            const progressStepWidth = (100 - fontProgressSlice) / paymentCount;

            // 匯出狀態歸零
            this.isExporting = true;
            this.processPercentage = 0;
            this.updateProcessMsg('載入字型檔中...');

            // 字型下載期間用 rAF ticker 驅動進度條平滑前進；真實下載進度僅 catch-up 與更新文字
            let ticker = null;
            if (fontProgressSlice > 0) {
                ticker = startEstimatedProgressTicker({
                    estimatedMs: 5000,
                    onTick: (pct) => { this.processPercentage = pct * fontProgressSlice; },
                });
            }

            await ensureNotoSansTCFontsLoaded(({
                label,
                index,
                total,
                received,
                contentLength,
            }) => {
                const mb = (received / 1048576).toFixed(1);
                if (contentLength) {
                    const totalMb = (contentLength / 1048576).toFixed(1);
                    const pct = Math.floor((received / contentLength) * 100);
                    this.updateProcessMsg(`載入字型檔 ${label} (${index + 1}/${total}): ${mb} / ${totalMb} MB (${pct}%)`);
                    if (ticker) ticker.setExternal((index + received / contentLength) / total);
                } else {
                    this.updateProcessMsg(`載入字型檔 ${label} (${index + 1}/${total}): ${mb} MB`);
                }
            });

            if (ticker) ticker.stop();
            this.processPercentage = fontProgressSlice;
            this.updateProcessMsg('開始匯出');

            // 載入公司 Logo
            let logoBase64 = null;
            if (this.form.enableDrawLogo) {
                logoBase64 = await this.fetchCmpLogoBase64();
            }

            // 逐一處理每個張請款
            const pdfFiles = [];
            for (let i = 0; i < paymentCount; i += 1) {
                const paymentSno = this.snoList[i];
                let msgPrefix = `請款單(${i + 1}/${paymentCount})：`;
                this.updateProcessMsg(`${msgPrefix}載入資料...`);

                // 更新進度條
                this.processPercentage = fontProgressSlice + i * progressStepWidth;

                // 取得請款單細節
                const detail = await this.fetchPaymentDetail(paymentSno);

                if (detail) {
                    msgPrefix = `請款單(${i + 1}/${paymentCount}) ${detail.payoo}：`;
                    this.updateProcessMsg(`${msgPrefix}匯出請款內容...`);
                    const pdfParts = [];

                    // 建立請款單細節 PDF 內容
                    if (this.form.enableDrawPaymentDetail) {
                        // 先把請款單raw data 預先格式化為匯出資料
                        const formatedDetail = PaymentDetailPdfFormater(detail, this.$store.getters['statement/statementUiOptions']);

                        // 使用 PdfMake 產生 PDF
                        const detailsPdf = await this.generatePdfBlob(PaymentDetailPdfDef({
                            ...formatedDetail, // 請款單內容
                            logoImg: logoBase64, // logo
                            enableDrawAuditProgress: this.form.enableDrawAuditProgress, // 是否有審核流程
                            enableDrawCreatorSignRect: this.form.enableDrawCreatorSignRect, // 是否有申請人簽章框
                            enableDrawReceiverSignRect: this.form.enableDrawReceiverSignRect, // 是否有收款人簽章框
                            enableDrawAuditSignRect: this.form.enableDrawAuditSignRect, // 是否有審核人簽章框
                        }));

                        // 加入到合併匯出陣列中
                        pdfParts.push(detailsPdf);
                    }

                    // 建立檢附單據 PDF 內容
                    if (this.form.enableDrawReceipts) {
                        // 取得檢附單據資料
                        this.updateProcessMsg(`${msgPrefix}載入單據...`);
                        const receiptsData = await this.fetchPaymentReceipts(paymentSno);
                        const receiptCount = receiptsData?.length;

                        // 如果有檢核單據
                        if (receiptsData) {
                            for (let r = 0; r < receiptCount; r += 1) {
                                // 更新進度條
                                this.updateProcessMsg(`${msgPrefix}匯出單據(${r + 1}/${receiptCount})...`);
                                const progressReceiptStepWidth = progressStepWidth / receiptCount;
                                this.processPercentage = fontProgressSlice + i * progressStepWidth + r * progressReceiptStepWidth;

                                const receipt = receiptsData[r]; // 單據資料
                                const fileUrl = receipt.filE_ATT; // 單據檔案網址
                                const fileExt = fileUrl.split('.').pop()?.toLowerCase(); // 副檔名

                                // 格式化單據匯出資料
                                const formatedReceipt = PaymentReceiptPdfFormater({
                                    ...receipt,
                                    totalReceiptCount: receiptCount,
                                    currReceiptNumber: r + 1,
                                });

                                let embedPdf = null;
                                let embedPdfStatus = 'ERROR_UNKNOWN';
                                // PDF 類型，預先載入（用來判斷是否載入成功）
                                if (fileExt === 'pdf') {
                                    const result = await this.embedPdf(receipt.base64Url);

                                    if (result.status === 'SUCCESS') {
                                        embedPdf = result.blob;
                                        embedPdfStatus = 'SUCCESS';
                                    } else {
                                        embedPdfStatus = result.status; // 可能是 "ERROR_ENCRYPT" 或 "ERROR_UNKNOWN"
                                    }
                                }

                                // 產生單據 PDF
                                const receiptPdf = await this.generatePdfBlob(PaymentReceiptPdfDef({ ...formatedReceipt, embedPdfStatus }));

                                // 加入到合併匯出陣列中
                                pdfParts.push(receiptPdf);

                                // PDF 類型，另外合併
                                if (fileExt === 'pdf') {
                                    if (embedPdf) {
                                        pdfParts.push(embedPdf);
                                    }
                                }
                            }
                        }
                    }

                    // 建立傳票 PDF 內容
                    if (this.form.enableDrawVouchers) {
                        this.updateProcessMsg(`${msgPrefix}載入傳票...`);
                        const voucherList = await this.fetchPaymentVouchers(detail.payoo);
                        if (voucherList) {
                            for (let v = 0; v < voucherList.length; v += 1) {
                                this.updateProcessMsg(`${msgPrefix}匯出傳票(${v + 1}/${voucherList.length})...`);

                                // 傳票資料匯出格式化
                                const vhData = VoucherPdfFormater(
                                    voucherList[v],
                                    this.companyName,
                                    this.form.voucherOrientation === 'landscape' ? 'A5' : 'A4',
                                    this.form.voucherOrientation,
                                );

                                // 製作傳票 PDF
                                const vhPdf = await this.generatePdfBlob(VoucherPdfDef(vhData));

                                // 加入到合併匯出陣列中
                                pdfParts.push(vhPdf);
                            }
                        }
                    }

                    // 合併單一請款單產生的 PDF 內容為一份 PDF 檔
                    const mergedPdfBlob = await this.mergePdfs(pdfParts);

                    // 加入到檔案陣列，供之後合併為 ZIP
                    pdfFiles.push({
                        fileName: this.formatePdfFileName(detail),
                        data: mergedPdfBlob,
                    });
                }
            }

            // 壓縮並下載
            this.updateProcessMsg('打包壓縮中...');
            this.createZip(pdfFiles, `請款單 ${moment().format('YYYY-MM-DD HH-mm-ss')}`);

            this.updateProcessMsg('');
            this.processPercentage = 100;
            this.isExporting = false;
        },

        // 合併 PDF Blobs 成一個 PDF 檔案
        /* eslint-disable no-await-in-loop */
        async mergePdfs(pdfBlobs) {
            const mergedPdf = await PDFDocument.create();

            // eslint-disable-next-line no-restricted-syntax
            for (const pdfBlob of pdfBlobs) {
                const pdfData = await pdfBlob.arrayBuffer();
                const pdf = await PDFDocument.load(pdfData);
                const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());

                copiedPages.forEach((page) => {
                    mergedPdf.addPage(page);
                });
            }

            const mergedPdfBlob = await mergedPdf.save();
            return new Blob([mergedPdfBlob], { type: 'application/pdf' });
        },

        // 更新匯出進度文字
        updateProcessMsg(msg) {
            this.processMsg = msg;
        },

        // 產生 ZIP 壓縮檔並下載
        createZip(fileList, rootFolderName) {
            const zip = new JSZip();
            const folder = zip.folder(rootFolderName);

            // 將每個檔案加入 ZIP
            fileList.forEach((f) => {
                folder.file(f.fileName, f.data, { binary: true });
            });

            // 生成 ZIP 並下載
            zip.generateAsync({ type: 'blob' }).then((content) => {
                const url = URL.createObjectURL(content);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${rootFolderName}.zip`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
        },

        // 產生統一檔名
        formatePdfFileName(detail) {
            const desireName = `請款單-${detail.payoo}-${detail.cny}-${detail.amt}.pdf`;
            return desireName.replaceAll('\\', ' ').replaceAll('/', ' '); // 去除一些會產生錯誤的字元laybel
        },

        // 取得請款單細節
        async fetchPaymentDetail(sno) {
            try {
                const resp = await this.$api_silent({
                    url: '/PaymentManagenmentPage/GetPaymentInfo',
                    method: 'GET',
                    params: { Sno: sno },
                });
                return resp.data.item;
            } catch (ex) {
                console.error('fetchDetailData error', ex);
                return null;
            }
        },

        // 得請款單檢附單據
        async fetchPaymentReceipts(sno) {
            try {
                const resp = await this.$api({
                    url: '/PaymentManagenmentPage/GetReciptFile',
                    method: 'GET',
                    params: { sno },
                });
                return resp.data.items?.reverse();
            } catch (ex) {
                console.error('fetchReceipts error', ex);
                return null;
            }
        },

        // 取得請款單的傳票
        async fetchPaymentVouchers(payoo) {
            try {
                const resp = await this.$api_silent({
                    url: `/AccountingSummaryPage/GetVouchers?UNT_NBR=${payoo}`,
                    method: 'GET',
                });
                return resp.data.items;
            } catch (ex) {
                console.error('fetch Voucher Data error', ex);
                return null;
            }
        },

        // 產生 PDF 檔的 Blob (PDFMake)
        async generatePdfBlob(docDefinition) {
            return new Promise((resolve) => {
                pdfMake.createPdf(docDefinition).getBlob((blob) => {
                    resolve(blob);
                });
            });
        },

        // 嵌入 PDF 檔案
        async embedPdf(base64Url) {
            try {
                // 創建新的 PDF 文檔
                const doc = await PDFDocument.create();
                const base64WithOutPrefix = base64Url.split(',')[1];

                try {
                    // 嘗試載入 PDF
                    const sourcePdfDoc = await PDFDocument.load(base64WithOutPrefix);

                    // 複製頁面（需用 copyPages 而非 embedPages，因為 embedPages 只會擷取頁面內容流，
                    // 會遺失以 Annotation 形式存在的內容，例如簽名圖章）
                    const copiedPages = await doc.copyPages(sourcePdfDoc, sourcePdfDoc.getPageIndices());
                    copiedPages.forEach((page) => {
                        doc.addPage(page);
                    });

                    // 轉換為 Blob
                    const pdfBytes = await doc.save();
                    const blob = new Blob([pdfBytes], { type: 'application/pdf' });

                    // ✅ 成功
                    return { status: 'SUCCESS', blob };
                } catch (pdfLoadError) {
                    if (pdfLoadError.message.includes('encrypted')) {
                        console.error('❌ PDF 加密，請先解密後再上傳！');
                        return { status: 'ERROR_ENCRYPT', blob: null };
                    }
                    console.error('❌ PDF 載入失敗：', pdfLoadError);
                    return { status: 'ERROR_UNKNOWN', blob: null };
                }
            } catch (ex) {
                console.error('❌ 其他錯誤：', ex);
                return { status: 'ERROR_UNKNOWN', blob: null };
            }
        },

        // 將目前勾選參數儲存到 LocalStorage
        saveSettingsToLocalStorage() {
            Object.keys(this.form).forEach((key) => {
                const localStorageKey = `paymentExportPDF-${key}`;
                localStorage.setItem(localStorageKey, this.form[key]);
            });
        },

        loadSettingsFromLocalStorage() {
            const boolKeys = [
                'enableDrawPaymentDetail',
                'enableDrawLogo',
                'enableDrawAuditProgress',
                'enableDrawReceipts',
                'enableDrawCreatorSignRect',
                'enableDrawReceiverSignRect',
                'enableDrawAuditSignRect',
                'enableDrawVouchers',
            ];
            const intKeys = [];

            Object.keys(this.form).forEach((key) => {
                const localStorageKey = `paymentExportPDF-${key}`;
                const value = localStorage.getItem(localStorageKey);
                if (value !== null) {
                    if (boolKeys.includes(key)) {
                        this.form[key] = value === 'true';
                    } else if (intKeys.includes(key)) {
                        this.form[key] = parseInt(value, 10);
                    } else {
                        this.form[key] = value;
                    }
                }
            });
        },
    },
};
</script>
<style lang="scss">
.payment-export-pdf-dialog {
    --pdf-preview-line-color: #aaa;
    --pdf-preview-text-color: #aaa;

    >.el-dialog {
        width: 800px;

        @media (max-width: 800px) {
            width: 90%;
        }
    }

    .export-pdf-layout {
        position: relative;
        display: grid;
        grid-template-columns: 480px 320px;

        @media (max-width: 800px) {
            display: block;
        }
    }

    .preview-view {
        background-color: #eee;
        border-bottom-left-radius: 10px;

        >.preview-area {
            display: flex;
            justify-content: center;
            align-items: flex-start;
            width: 100%;
            height: 450px;
            overflow-y: auto;

            >.preview-list {
                display: flex;
                flex-direction: column;
                gap: 10px;
                padding: 75px 0 75px 0;

                >.preview-doc {
                    position: relative;

                    >.preview-page {
                        position: relative;
                        padding: 20px;
                        display: block;
                        width: 200px;
                        height: 270px;
                        background-color: #fff;
                        border: 1px solid #aaa;
                        box-shadow: 2px 2px 6px rgba(0,0,0,0.2);
                        z-index: 3;

                        &:nth-child(2) {
                            position: absolute;
                            top: 20px;
                            left: 20px;
                            z-index: 2;
                        }

                        &:nth-child(3) {
                            position: absolute;
                            top: 40px;
                            left: 40px;
                            z-index: 1;
                        }

                        .title-text {
                            display: inline-block;
                            height: 2px;
                            width: 30px;
                            background-color: var(--pdf-preview-text-color);
                        }
                        .text-line {
                            display: flex;
                            margin: 0 0 5px 0;
                            gap: 5px;

                            >.text:first-child {
                                width: 15px;
                            }
                        }
                        .text {
                            display: inline-block;
                            height: 2px;
                            width: 30px;
                            background-color: var(--pdf-preview-text-color);
                        }
                        .title-text-line {
                            display: block;
                            height: 2px;
                            width: 30px;
                            background-color: var(--pdf-preview-text-color);
                            margin-bottom: 4px;
                        }

                        &.detail {
                            .title {
                                font-size: 10pt;
                                font-weight: bold;
                                margin-bottom: 8px;
                            }

                            .logo {
                                position: absolute;
                                right: 20px;
                                top: 20px;
                                height: 18px;
                                line-height: 18px;
                                background-color: #eee;
                                font-size: 9pt;
                                color: #888;
                                padding: 0px 10px;
                                font-weight: bold;
                            }
                            .audits {
                                position: absolute;
                                display: flex;
                                top: 50px;
                                right: 20px;
                                width: 80px;
                                height: 10px;
                                justify-content: space-between;

                                >.line {
                                    position: absolute;
                                    top: 5px;
                                    left: 0;
                                    width: 100%;
                                    height: 2px;
                                    background-color: #aaa;
                                }

                                >.dot {
                                    position: relative;
                                    top: 2px;
                                    width: 8px;
                                    height: 8px;
                                    border-radius: 50%;
                                    background-color: #fff;
                                    border: 2px solid #aaa;
                                }
                            }
                            .section {
                                margin-top: 15px;
                                .section-title {
                                    line-height: 12px;
                                    font-size: 5pt;
                                    font-weight: bold;
                                    border-bottom: 2px solid var(--pdf-preview-line-color);
                                    margin-bottom: 7px;
                                }
                            }

                            .section.sign {
                                margin-top: 15px;
                                display: grid;
                                grid-template-columns: 25% auto 25%;
                                gap: 10px;

                                .signRect {
                                    position: relative;
                                    height: 30px;
                                    border-bottom: 2px solid var(--pdf-preview-line-color);

                                    &:before {
                                        position: absolute;
                                        bottom: 3px;
                                        left: 0;
                                        content: '';
                                        width: 15px;
                                        height: 2px;
                                        background-color: var(--pdf-preview-text-color);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .progress-view {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 20;

        >.progress-panel {
            width: 400px;
            background-color: #fff;
            padding: 25px;
            border-radius: 8px;

            .panel-title {
                font-size: 11pt;
                font-weight: bold;
                color: #000;
                margin-bottom: 15px;
            }
            .progress-msg {
                margin-top: 10px;
                font-size: 9pt;
                color: #666;
            }
        }
    }

    .setting-view {
        display: flex;
        flex-direction: column;

        >.setting-content {
            padding: 30px 40px;
            min-height: 350px;

            @media (max-width: 800px) {
                min-height: unset;
            }
        }

        >.actions {
            padding: 30px 40px;

            @media (max-width: 800px) {
                text-align: center;
            }
        }
    }

    .process {
        margin-bottom: 20px;
    }

    .custom-settings {
        line-height: 180%;
    }

}
</style>
